import { render, staticRenderFns } from "./studentLoginLog.vue?vue&type=template&id=1976c3ed&scoped=true"
import script from "./studentLoginLog.vue?vue&type=script&lang=js"
export * from "./studentLoginLog.vue?vue&type=script&lang=js"
import style0 from "./studentLoginLog.vue?vue&type=style&index=0&id=1976c3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976c3ed",
  null
  
)

export default component.exports